'use client';

import ProductInputTool from '@/app/[locale]/(seo)/(products)/_components/ProductInputTool';
import type { HeroSectionData, HeroToolType } from '../../types';
import { MediaAsset } from '../MediaAsset';
import { PortableTextContent } from '../PortableTextContent';

const TOOL_TYPE_TO_PATHNAME = {
  text2video: '/ai-text-to-video',
  text2image: '/ai-image-generator',
  reference2image: '/ai-image-generator',
  image2video: '/ai-image-to-video',
  reference2video: '/ai-reference-to-video',
} satisfies Record<HeroToolType, string>;

export function ProductStyleHero({ section }: { section: HeroSectionData }) {
  const pathname = section.toolType ? TOOL_TYPE_TO_PATHNAME[section.toolType] : undefined;

  return (
    <section className="pt-[164px] pb-20 sm:pt-16 sm:pb-12">
      <div className="mx-auto flex flex-col items-center px-4">
        <div className="mx-auto min-h-[140px] w-full max-w-[50vw] text-center md:max-w-full">
          <h1 className="mb-4 font-semibold text-5xl leading-tight sm:text-4xl">{section.title}</h1>
          {section.description && (
            <PortableTextContent className="mb-12 text-xl sm:mb-6 sm:text-base" value={section.description} />
          )}
        </div>
        {pathname && (
          <div className="mx-auto min-h-[140px] w-full max-w-[50vw] md:max-w-full">
            <ProductInputTool pathname={pathname} />
          </div>
        )}
        {section.showcaseMedia && (
          <div className="mt-12 aspect-video w-[74vw] overflow-hidden rounded-xl">
            <MediaAsset media={section.showcaseMedia} />
          </div>
        )}
      </div>
    </section>
  );
}
